import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewFooterComponent } from './new-footer.component';

@NgModule({
  declarations: [[NewFooterComponent]],
  imports: [CommonModule],
  exports: [[NewFooterComponent]]
})
export class NewFooterModule {}
